import React from 'react';
import { Box, Collapse, Alert, CircularProgress, Button } from '@mui/material';
import { useSystemStatus } from '../../context/SystemStatusContext';

const SystemMessageArea = () => {
  const { messages, removeMessage } = useSystemStatus();

  if (messages.length === 0) {
    return null;
  }

  return (
    <Box sx={{ p: 1, flexShrink: 0, width: '100%' }}>
      {messages.map(msg => {
        // An alert is closable if it has an onClose callback or if it's an error.
        const isClosable = !!msg.onClose || msg.severity === 'error';

        const handleClose = () => {
          if (msg.onClose) {
            msg.onClose();
          }
          removeMessage(msg.id);
        };

        return (
          <Collapse in={true} key={msg.id}>
            <Alert
              severity={msg.severity || 'info'}
              onClose={isClosable ? handleClose : undefined}
              icon={msg.isLoading ? <CircularProgress size={20} /> : undefined}
              action={msg.action && (
                <Button color="inherit" size="small" onClick={msg.action.onClick}>{msg.action.label}</Button>
              )}
              sx={{ mb: 1, alignItems: 'center' }}
            >{msg.text}</Alert>
          </Collapse>
        );
      })}
    </Box>
  );
};

export default SystemMessageArea;